// extracted by mini-css-extract-plugin
module.exports = {"head":"style_head__ifla7","bg":"style_bg__56PSt","titleWrap":"style_titleWrap__QP623","mainTitle":"style_mainTitle__7xjUF","subtitle":"style_subtitle__4C2_A"};